import styled from 'styled-components';

export const StyledInfoContainer = styled.div`
  box-shadow: 0px 2px 8px 0px rgba(0, 0, 0, 0.15);
  border-radius: 4px;
  background: #fff;
  margin-bottom: 20px;

  
  .static-text{
    color: rgba(140, 140, 140, 1);
  }
  
  .fulfilled{
    .ant-collapse-header{
      background: #E6F3E5; //fulfilled tab
    }
  }
  
  .empty{
    .ant-collapse-header{
      background: #FFF7EA; // empty tab
    }
  }
  
  .ant{
    &-tabs{
      &-nav{
        background: #FAFAFA;
        margin-bottom: 0;
        
        &-wrap{
          margin-left: 20px;
        }
      }
    }
  }
`

export const StyledSemesterContainer = styled.div`
  
`